import useAuth from '../../../auth/useAuth';
import styles from './registrationProfil.module.scss';

const RegistrationProfil = () => {
  const { isManager } = useAuth({});

  const role = isManager ? 'Manager' : 'Prospecteur';

  return (
    <div className={styles.container}>
      <h3>Profil</h3>
      <span className={styles.data}>{role}</span>
    </div>
  );
};

export default RegistrationProfil;
